<template>
  <div>
    <CRow>
      <CCol col>
        <CCard>
          <CCardHeader>
            <strong> Modulo Egresos Administrativos - Listar</strong>
          </CCardHeader>
          <CCardBody>
            <b-row>
         

                <b-col sm="12" md="8">
          
                </b-col>

                
                <b-col sm="6" md="3">
                  <b-form-group label=".">
                    <b-input-group>
                    <b-form-input v-model="search" class="form-control"></b-form-input>
                    <b-input-group-append>
                      <b-button variant="primary" @click="ListExpense"><b-icon icon="search"></b-icon></b-button>
                    </b-input-group-append>
                  </b-input-group>
                  </b-form-group>
                </b-col>

                <b-col sm="6" md="1">
                  <b-form-group label=".">
                    <b-link  v-if="Permission('ExpenseAdd')" class="btn form-control btn-primary"  :to="{ path: '/egreso-administrativo/nuevo' }" append ><i class="fas fa-file"></i></b-link>
                  </b-form-group>
                </b-col>
            </b-row>

            <div class="table-responsive mt-3 height-table">
              <table class="table table-hover table-bordered">
                <thead>
                  <tr>
                    <th width="3%" class="text-center">#</th>
                    <th width="8%" class="text-center">Fecha</th>
                    <th width="40%" class="text-center">Cliente</th>
                    <th width="12%" class="text-center">Tipo</th>
                    <th width="12%" class="text-center">Medio Pago</th>
                    <th width="8%" class="text-center">Total</th>
                    <th width="7%" class="text-center">Estado</th>
                    <th width="7%" class="text-center">Acciones</th>
                  </tr>
                </thead>
                <tbody v-for="(item, it) in data_table" :key="it">
                  <tr>
                    <td class="text-center">{{ it + 1 }}</td>
                    <td class="text-center"> {{ item.date  }}</td>
                    <td class="text-left"> {{ item.client_name  }}</td>
                    <td class="text-left"> {{ item.name_method  }}</td>
                    <td class="text-left"> {{ NameMethodPayment(item.payment_method)  }}</td>
                    <td class="text-right"> {{ item.total  }}</td>
                    <td class="text-center">
                        <b-badge v-if="item.state == 1" variant="success">Activo</b-badge>
                        <b-badge v-if="item.state == 0" variant="danger">Inactivo</b-badge>
                    </td>
                    <td class="text-center">
                      <b-dropdown bloque size="sm" text="Acciones" right>
                        <b-dropdown-item v-if="Permission('ExpenseEdit')" @click="EditExpense(item.id_expense)" >Editar</b-dropdown-item>
                        <b-dropdown-item v-if="Permission('ExpenseView')" @click="ViewExpense(item.id_expense)" >Ver</b-dropdown-item>
                        <b-dropdown-item  v-if="Permission('ExpenseDelete')" @click="ConfirmDeleteExpense(item.id_expense)" >Eliminar</b-dropdown-item>
                      </b-dropdown>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <b-row class="mt-4">
              <b-col md="8">
                <b-pagination v-model="currentPage" v-on:input="ListExpense" :total-rows="rows" :per-page="perPage" align="center" ></b-pagination>
              </b-col>
              <b-col md="4 text-center">
                <p>Pagina Actual: {{ currentPage }}</p>
              </b-col>
            </b-row>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import vSelect from "vue-select";
import 'vue-select/dist/vue-select.css';
import "vue-select/src/scss/vue-select.scss";

const axios = require("axios").default;
const Swal = require("sweetalert2");
const je = require("json-encrypt");
import { mapState } from "vuex";
import CodeToName from "@/assets/js/CodeToName";
var moment = require("moment");
export default {
  name: "IncomeList",
  components:{
    vSelect,
  },
  data() {
    return {
      module:'Expense',
      perPage: 15,
      currentPage: 1,
      rows: 0,
      data_table: [],
      search: "",
    };
  },
  mounted() {
    this.ListExpense();
  },
  methods: {
    ListExpense,
    EditExpense,
    ViewExpense,
    ConfirmDeleteExpense,
    DeleteExpense,
    Permission,
    NameMethodPayment,

  },

  computed: {
    ...mapState(["url_base"]),
    token: function () {
      let user = window.localStorage.getItem("user");
      user = JSON.parse(JSON.parse(je.decrypt(user)));
      return user.api_token;
    },
    user: function () {
      let user = window.localStorage.getItem("user");
      user = JSON.parse(JSON.parse(je.decrypt(user)));
      return user;
    }
  },
};

function NameMethodPayment(code) {
  return CodeToName.NameMethodPayment(code);
}

function ListExpense() {

  let search = this.search == "" ? "all" : this.search;
  let me = this;
  let url = this.url_base + "expense/list/"+ this.user.id_user +"/"+search + "?page=" + this.currentPage;

  axios({
    method: "GET",
    url: url,
    headers: { token: this.token, module: this.module, role: 1,},
  })
    .then(function (response) {
      if (response.data.status == 200) {
        me.rows = response.data.result.total;
        me.data_table = response.data.result.data;
      } else {
        Swal.fire({ icon: 'error', text: 'A ocurrido un error', timer: 3000,})
      }
    })
    .catch((error) => {
      Swal.fire({ icon: 'error', text: 'A ocurrido un error', timer: 3000,})
    });
}

// Editar usuario
function EditExpense(id_expense) {
  this.$router.push({
    name: "ExpenseEdit",
    params: { id_expense: je.encrypt(id_expense) },
  });
}

// Ver Usuario
function ViewExpense(id_expense) {
  this.$router.push({
    name: "ExpenseView",
    params: { id_expense: je.encrypt(id_expense) },
  });
}

// Confirmar eliminar
function ConfirmDeleteExpense(id_expense) {
  Swal.fire({
    title: "Esta seguro de eliminar el egreso administrativo?",
    text: "No podrás revertir esto!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Si, Estoy de acuerdo!",
  }).then((result) => {
    if (result.value) {
      this.DeleteExpense(id_expense);
    }
  });
}

// eliminar usuario
function DeleteExpense(id_expense) {
  let me = this;
  let url = this.url_base + "expense/delete/" + id_expense;
  axios({
    method: "delete",
    url: url,
    headers: {token: this.token, module: this.module,role: 4,},
  })
    .then(function (response) {
       if (response.data.status == 200) {
        const index = me.data_table.map(item => item.id_expense).indexOf(response.data.result.id_expense);
        me.data_table.splice(index, 1);
        Swal.fire({ icon: 'success', text: response.data.message, timer: 3000,})
      } else {
        Swal.fire({ icon: 'error', text: response.data.message, timer: 3000,})
      }
    })
    .catch((error) => {
      Swal.fire({ icon: 'error', text: 'A ocurrido un error', timer: 3000,})
    });
}

// permisos
function Permission(module_permission) {
  let user_permissions = window.localStorage.getItem("user_permissions");
  user_permissions = JSON.parse(JSON.parse(je.decrypt(user_permissions)));
  if (user_permissions.indexOf(module_permission) > -1) {
    return true;
  } else {
    return false;
  }
}
</script>